import React, { useEffect, useState } from 'react';
import { HealthService } from '../services/api/health';
import './ApiHealthCheck.css';

interface ApiHealthCheckProps {
  children: React.ReactNode;
  disablePeriodicChecks?: boolean;
}

const ApiHealthCheck: React.FC<ApiHealthCheckProps> = ({
  children,
  disablePeriodicChecks = true,
}) => {
  const [isApiHealthy, setIsApiHealthy] = useState<boolean | null>(null);
  const [isChecking, setIsChecking] = useState<boolean>(true);

  useEffect(() => {
    const checkHealth = async () => {
      setIsChecking(true);
      try {
        console.log('[ApiHealthCheck] Checking API health...');
        const healthy = await HealthService.checkHealth();
        console.log('[ApiHealthCheck] API health status:', healthy);
        setIsApiHealthy(healthy);
      } catch (error) {
        console.error('[ApiHealthCheck] Error checking API health:', error);
        setIsApiHealthy(false);
      } finally {
        setIsChecking(false);
      }
    };

    // Initial health check
    void checkHealth();

    // Set up periodic health check only if not disabled
    let intervalId: NodeJS.Timeout | undefined;
    if (!disablePeriodicChecks) {
      intervalId = setInterval(checkHealth, 300000); // Check every 5 minutes
    }

    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [disablePeriodicChecks]);

  if (isChecking) {
    return (
      <div className="api-health-checking">
        <p>Checking API connection...</p>
      </div>
    );
  }

  if (isApiHealthy === false) {
    return (
      <div
        className="api-health-error-container"
        dangerouslySetInnerHTML={{ __html: HealthService.getErrorMessage() }}
      />
    );
  }

  return <>{children}</>;
};

export default ApiHealthCheck;
